import { LogoutOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Avatar, Button, Dropdown, Menu, message, notification, Tooltip } from "antd";
import { jwtDecode, JwtPayload } from "jwt-decode";
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { loginUser } from './api/login';
import './App.css';
import ChangeEmailModal from './components/ChangeEmailComponnent';
import ChangeLicenseModal from './components/ChangeLicenseComponent';
import CustomCalender from './components/CustomCalendarComponent';
import LoginModal from './components/LoginComponent';
import RegisterModal from './components/RegisterComponent';
import ResetPasswordModal from './components/ResetPasswordCompenent';
import { BrokerData, LoginRequest, LoginResponse } from './constant';
import Accounting from './pages/Accounting';
import FilingHistory from './pages/FilingHistory';
import Help from './pages/Help';
import Home from './pages/Home';
import LateFilings from './pages/LateFilings';
import NewFiling from './pages/NewFiling';
import Reports from './pages/Reports';
import SearchFiling from './pages/SearchFiling';
import {API_URL} from './constant';
import NewVersionAlert from './components/WelcomeComponent';
import { api_getNotice } from './api/updateWelcome';
import WarningAlert from './components/WarningComponent';
import OPTins from './pages/OPTins';
import BulkEmail from './pages/BulkEmail';
import { useLocation, useNavigate } from "react-router-dom";
import OPTinsImport from './pages/OPTinsImport';
import BrokerBalance from './pages/BrokerBalance';
import { api_RecalcOptBalance } from './api/loadOPTList';

const App: React.FC = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  // const [isLogin, setIsLogin] = useState(
  //   token ? true : false
  // )
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [userData, setUserData] = useState<{ [key: string]: string }>({})
  const [activeKey, setActiveKey] = useState("1");
  const [carriers, setCarriers] = useState<string[]>([]);
  const [users, setUsers] = useState<{ [key: string]: string }>({});
  const [slcodes, setSlCodes] = useState<{ [key: string]: string }>({});
  const [openRegister, setOpenRegister] = useState(false);
  const [resetPwd, setResetPwd] = useState(false);
  const [changeEmail, setChangeEmail] = useState(false);
  const [isLoginModal, setIsLoginModal] = useState(false);
  const [isTooltip, setIsTooltip] = useState(false);
  const [pastTax, setPastTax] = useState<string>("");
  const [pastTaxDue, setPastTaxDue] = useState<string>("");
  const [nextTax, setNextTax] = useState<string>("");
  const [nextTaxDue, setNextTaxDue] = useState<string>("");
  const [isChangeLicense, setisIsChangeLicense] = useState(false);
  const [licenseNumber, setLicenseNumber] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [broker, setBroker] = useState<BrokerData | null> (null)
  const [welcomeNotice, setWelcomeNotice] = useState(false);
  const [warningNotice, setWarningNotice] = useState(false);
  const [latesearch, setLateSearch] = useState<string>("");
  const [latelicense, setLateLicense] = useState<string>("");


  /**
   * Determines the current tax period and updates related state variables accordingly.
   *
   * This function calculates which tax period the current date falls into based on predefined date ranges:
   * - "B" period: January 1 to February 15
   * - "A" period: February 16 to August 15
   * - "B" period (second half): August 16 to December 31
   *
   * Depending on the current date, it sets the next and past tax period labels and their due dates
   * using the provided state setters (`setNextTax`, `setNextTaxDue`, `setPastTax`, `setPastTaxDue`).
   *
   * @remarks
   * The function assumes the existence of state setter functions in the component's scope.
   * The tax period labels are formatted as `${year}A` or `${year}B`, and due dates are formatted as `MM/DD/YY`.
   */
  const getPeriodForCurrentDate = () => {
    const today = new Date();
    const currentYear = today.getFullYear();

    const startB = new Date(currentYear, 0, 1);
    const endB = new Date(currentYear, 1, 15);

    const startA = new Date(currentYear, 1, 16);
    const endA = new Date(currentYear, 7, 15);

    const startB2 = new Date(currentYear, 7, 16);
    const endB2 = new Date(currentYear, 11, 31);
    const year = currentYear % 100;

    if (today >= startB && today <= endB) {
      setNextTax(`${currentYear - 1}B`)
      setNextTaxDue(`2/15/${year}`)
      setPastTax(`${currentYear - 1}A`)
      setPastTaxDue(`8/15/${year - 1}`)
    }

    if (today >= startA && today <= endA) {
      setNextTax(`${currentYear}A`)
      setNextTaxDue(`8/15/${year}`)
      setPastTax(`${currentYear - 1}B`)
      setPastTaxDue(`2/15/${year}`)
    }

    if (today >= startB2 && today <= endB2) {
      setNextTax(`${currentYear}B`)
      setNextTaxDue(`2/15/${year + 1}`)
      setPastTax(`${currentYear}A`)
      setPastTaxDue(`8/15/${year}`)
    }
  }

  useLayoutEffect(() => {
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);
    
  useEffect(() => {
    //localStorage.clear()
    getPeriodForCurrentDate()
    if (isLogin) {
      const storedata = localStorage.getItem("session")
      let parsedLoginResponse: LoginResponse | null = null;
      if (storedata) {
        try {
          parsedLoginResponse = JSON.parse(storedata) as LoginResponse;
          if (parsedLoginResponse.login_session.user.userType !== '0') {
            setActiveKey("3")
          } else {
            setActiveKey("2")
          }
          setUserData(parsedLoginResponse.login_session.user)
          setCarriers(parsedLoginResponse.login_session.carriers)
          setUsers(parsedLoginResponse.login_session.users)
          setSlCodes(parsedLoginResponse.login_session.slcodes)
          setUserEmail(parsedLoginResponse.login_session.user.emailAddress)
          setLicenseNumber(parsedLoginResponse.login_session.user.licenseNumber)
          // if (parsedLoginResponse.login_session.welcomeNotice === 0){
          //   setWelcomeNotice(true);
          // }
          // else{
          //   setWelcomeNotice(false);
          // }
        } catch (error) {
          console.error("localStorage data parsing error:", error);
        }
      }
      api_getNotice()
      .then((response) => {
        if ("welcome" in response) {
          console.log("Notice Status: ", response);
          setWelcomeNotice(response.welcome === 0);
          setWarningNotice(response.warning === 0);
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        return
      });
    }
  }, []);

  // useEffect(() => {
  //   if (!token) return;

  //   const decoded = jwtDecode<JwtPayload>(token);
  //   const expirationTime = decoded.exp ? decoded.exp * 1000 : 0; // Convert to milliseconds
  //   const timeout = expirationTime - Date.now();

  //   if (timeout > 0) {
  //     const timer = setTimeout(() => {
  //       notification.warning({
  //         message: "Session Expired",
  //         description: "Please login again.",
  //       });
  //       localStorage.removeItem("token");
  //       window.location.reload()
  //     }, timeout);

  //     return () => clearTimeout(timer);
  //   } else {
  //     // Token already expired
  //     localStorage.removeItem("token");
  //     window.location.reload()
  //   }
  // }, [token]);

  useEffect(() => {
    if (broker)
    {
      setLicenseNumber(broker.stateID)
      //setUserEmail(broker.email)
      var prevUser = userData
      prevUser.name = broker.brokername;
      prevUser.licenseNumber = broker.stateID;
      prevUser.emailAddress = broker.email;
      prevUser.licenseeName = broker.brokername;
      prevUser.SBSID=broker.sbsID
      setUserData(prevUser)
    }
  }, [broker]);

  const onClickLogin = () => {
    if (isLogin) {
      localStorage.clear();
      window.location.reload();
    }
  }

  const onLogin = (logindata: LoginRequest) => {
    if (isLogin) {
      localStorage.clear();
      window.location.reload();
    }

    loginUser(logindata.username, logindata.password)
    .then((loginResponse) => {
      if ("access_token" in loginResponse) {
        message.info('Login Success');
        setIsLogin(true)
        //window.location.reload();
        const storedata = localStorage.getItem("session")
        let parsedLoginResponse: LoginResponse | null = null;
        if (storedata) {
          try {
            parsedLoginResponse = JSON.parse(storedata) as LoginResponse;
            if (parsedLoginResponse.login_session.user.userType !== '0') {
              setActiveKey("3")
            } else {
              setActiveKey("2")
            }
            setUserData(parsedLoginResponse.login_session.user)
            setCarriers(parsedLoginResponse.login_session.carriers)
            setUsers(parsedLoginResponse.login_session.users)
            setSlCodes(parsedLoginResponse.login_session.slcodes)
            setUserEmail(parsedLoginResponse.login_session.user.emailAddress)
            setLicenseNumber(parsedLoginResponse.login_session.user.licenseNumber)
            // if (parsedLoginResponse.login_session.welcomeNotice === 0){
            //   setWelcomeNotice(true);
            // }
            // else{
            //   setWelcomeNotice(false);
            // }
            console.log("Login Response: ", parsedLoginResponse.login_session.user.username);
            if (parsedLoginResponse.login_session.user.username == 'recalc')
            {
              api_RecalcOptBalance()
              .then((response) => {
                if (response.success) {
                  console.log("OPT Balance Recalculation Success");
                }           
                else {
                  console.log("OPT Balance Recalculation Failed: ", response.errorMsg);
                }
              })
              .catch((error) => {
                console.error("An error occurred:", error.message);
                return
              });
            }

          } catch (error) {
            console.error("localStorage data parsing error:", error);
          }
        }
        api_getNotice()
        .then((response) => {
          if ("welcome" in response) {
            console.log("Notice Status: ", response);
            setWelcomeNotice(response.welcome === 0);
            setWarningNotice(response.warning === 0);
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });

      } else {
        if(loginResponse.errorMsg === "Lock"){
          alert("Your account has been restricted.  Please call 602-279-6344 for assistance")
        }else{
          message.error(loginResponse.errorMsg);
        }
        setIsLogin(false)
        return
      }
    })
    .catch((error) => {
      console.error("An error occurred:", error.message);
      return
    });
  }

  const handleMenuClick = (e: any) => {
    setActiveKey(e.key);
  };

  const showLoginModal = () => {
    setIsLoginModal(true);
  };

  const showRegisterModal = () => {
    setOpenRegister(true);
  };

  const handleRegisterCancel = () => {
    setOpenRegister(false);
  };

  const showResetPwdModal = () => {
    setIsLoginModal(false)
    setResetPwd(true);
  };

  const handleResetPwdCancel = () => {
    setResetPwd(false);
  };

  const showChangeEmailModal = () => {
    setChangeEmail(true);
  };

  const handleChangeEmailCancel = () => {
    setChangeEmail(false);
  };

  const handleLoginCancel = () => {
    setIsLoginModal(false)
  }

  const handleClickAvatar = () => {
    setIsTooltip((prev) => !prev);
  };

  const showChangeLicenseModal = () => {
    setisIsChangeLicense(true);
  };

  const handleChangeLicenseCancel = () => {
    setisIsChangeLicense(false);
  };

  const onMoveHome = () => {
    window.location.href = `${API_URL}`
  }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Button type="text" icon={<MailOutlined />} onClick={showChangeEmailModal}>Change Email</Button>
      ),
    },
    ...(userData.userType !== '0'
      ? [
        {
          key: '3',
          label: (
            <Button type="text" icon={<UserOutlined />} onClick={showChangeLicenseModal}>
              Change License
            </Button>
          ),
        },
      ]
      : []),
    {
      key: '2',
      label: (
        <Button type="text" icon={<LogoutOutlined />} onClick={onClickLogin}>Log Out</Button>
      ),
    },
  ];

  return (
    <>
      {isLogin && <NewVersionAlert showmessage={welcomeNotice} />}
      {/* {isLogin && <WarningAlert showmessage={warningNotice} />} */}
      <div className='body-container'>
        <div className='header-container bg-gradient-to-b from-zinc-300 to-zinc-200'>
          <div className='flex flex-row'>
            <div className='basis-56'>
              <img src='images/Logo_Wide.png' onClick={onMoveHome}></img>
            </div>
            <div className='basis-40 mt-3 ml-6 content-center text-online justify-items-center font-bold text-xl' style={{ color: 'rgb(92, 38, 184)' }}>
              <p className="m-0">Online Filing</p>
              <p className="m-0">System</p>
            </div>
            <div className='basis-36 mt-3 content-center text-center font-bold text-xs text-style'>
              <p className="m-1">Past Tax Report</p>
              <p className="m-1">{pastTax}</p>
              <p className="m-1">Due: {pastTaxDue}</p>
            </div>
            <CustomCalender />
            <div className='basis-36 mt-3 content-center font-bold text-center  text-xs text-style'>
              <p className="m-1">Next Tax Report</p>
              <p className="m-1">{nextTax}</p>
              <p className="m-1">Due: <span className='text-red-500'>{nextTaxDue}</span></p>
            </div>


            <div className='relative hidden lg:flex mr-2 ml-auto mt-3'>
              {!isLogin ? (
                <div className='flex flex-row'>
                  <Button size='small' type="primary" className='ml-2 loginbutton-style' onClick={showLoginModal}>Login</Button>
                  <Button size='small' type="primary" className='ml-2 loginbutton-style' onClick={showRegisterModal}>Signup</Button>
                  <LoginModal visible={isLoginModal} onCancel={handleLoginCancel} onLogin={onLogin} showResetPwd={showResetPwdModal} />
                  <RegisterModal visible={openRegister} onCancel={handleRegisterCancel} />
                  <ResetPasswordModal visible={resetPwd} onCancel={handleResetPwdCancel} />
                </div>
              ) : (
                <div className='flex flex-row'>
                  <div className='text-xs item-start text-style mr-10 mt-2'>
                    <div>{userData.name}</div>
                    <div>{userData.licenseeName}<span>(SBS: {userData.SBSID})</span></div>
                    <div>{licenseNumber}</div>
                    <div>{userData.emailAddress}</div>
                    {userData.userType !== '0' && (
                      <div className='text-red-500'>Admin Email: {userEmail}</div>
                    )}
                  </div>
                  <div>
                    <Tooltip
                      title={
                        <div style={{ fontSize: '11px' }} className='text'>
                          <div >{userData.name}</div>
                          <div>{userData.licenseeName}<span>(SBS: {userData.SBSID})</span></div>
                          <div>{licenseNumber}</div>
                          <div><span >{userData.emailAddress}</span></div>
                        </div>
                      }
                      trigger="hover"
                      open={isTooltip}
                      onOpenChange={setIsTooltip}
                      placement='bottomLeft'
                      color={'rgb(115 115 115 / var(--tw-bg-opacity, 1))'}
                    >
                      <Dropdown menu={{ items }} trigger={['click']}>
                        <Avatar size={32} className='bg-green-500 mr-5 mt-2 avatar-style' icon={<UserOutlined />} onClick={handleClickAvatar} />
                      </Dropdown>
                    </Tooltip>
                    <ChangeEmailModal visible={changeEmail} usermail={userEmail} onCancel={handleChangeEmailCancel} onSetUserMail={setUserEmail} />
                    <ChangeLicenseModal visible={isChangeLicense} licenseNumber={licenseNumber} onCancel={handleChangeLicenseCancel} onSetlicenseNumber={setBroker} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{ height: '100%' }}>
          <Menu
            onClick={handleMenuClick}
            selectedKeys={[activeKey]}
            className="bg-gradient-to-b from-zinc-200 to-zinc-100 font-serif"
            mode="horizontal"
            style={{
              lineHeight: '40px', fontFamily: 'Arial, Verdana, sans-serif', fontSize: '15px'
            }}

          >
            <Menu.Item key="1" style={{ textAlign: 'center' }}>
              Home
            </Menu.Item>
            {isLogin && (<>
              {userData.userType === '0'  && (<>
                <Menu.Item key="2" style={{ textAlign: 'center' }}>
                  New Filing
                </Menu.Item></>)}
              {/* <Menu.Item key="3" style={{ textAlign: 'center' }}>
              Bulk Upload
            </Menu.Item> */}
              {userData.userType === '2' && (
                <Menu.Item key="12" style={{ textAlign: 'center' }}>
                  Bulk Email
                </Menu.Item>
              )}
              <Menu.Item key="3" style={{ textAlign: 'center' }}>
                Filing Search
              </Menu.Item>
              <Menu.Item key="4" style={{ textAlign: 'center' }}>
                Filing History
              </Menu.Item>
              <Menu.Item key="5" style={{ textAlign: 'center' }}>
                Late Filings
              </Menu.Item>
              <Menu.Item key="6" style={{ textAlign: 'center' }}>
                Accounting
              </Menu.Item>
              <Menu.Item key="7" style={{ textAlign: 'center' }}>
                Reports
              </Menu.Item>
              {userData.userType !== '0' && (<>
                <Menu.Item key="8" style={{ textAlign: 'center' }}>
                  OPTins Import
                </Menu.Item></>)}
              {userData.userType !== '0' && (<>
                <Menu.Item key="9" style={{ textAlign: 'center' }}>
                  OPTins
                </Menu.Item></>)}
              {userData.userType !== '0' && (<>
                <Menu.Item key="10" style={{ textAlign: 'center' }}>
                  Balances
                </Menu.Item></>)}
              <Menu.Item key="11" style={{ textAlign: 'center' }}>
                Help
              </Menu.Item>
            </>)}
          </Menu>

          <div>
            {activeKey === '1' && <Home />}
            {activeKey === '2' && <NewFiling user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '2'} />}
            {activeKey === '3' && <SearchFiling user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '3'} latesearch={latesearch}  setLateSearch={setLateSearch} latelicense={latelicense} setLateLicense={setLateLicense} />}
            {activeKey === '4' && <FilingHistory user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '4'} />}
            {activeKey === '5' && <LateFilings user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '5'} setActiveKey={setActiveKey} setLateSearch={setLateSearch} setLateLicense={setLateLicense} />}
            
            {/* <div style={{ display: activeKey === '5' ? 'block' : 'none' }}>
              <LateFilings user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '5'} setActiveKey={setActiveKey} setLateSearch={setLateSearch} setLateLicense={setLateLicense}/>
            </div> */}
            {activeKey === '6' && <Accounting user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '6'} />}
            {activeKey === '7' && <Reports user={userData} carriers={carriers} users={users} slcodes={slcodes} isSelected={activeKey === '7'} />}
            {activeKey === '8' && <OPTinsImport />}
            {activeKey === '9' && <OPTins user={userData} isSelected={activeKey === '9'} />}
            {activeKey === '10' && <BrokerBalance user={userData} isSelected={activeKey === '10'} />}
            {activeKey === '11' && <Help />}
            <div style={{ display: activeKey === '12' ? 'block' : 'none' }}>
              <BulkEmail />
            </div>
          </div>
        </div>
      </div>
    </>
    
  );
}

export default App;
